import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 items-center overflow-auto px-5 py-3 gap-5" }
const _hoisted_2 = { class: "col-span-12 md:col-span-2 text-xl font-bold" }
const _hoisted_3 = { class: "col-span-6 md:col-span-5" }
const _hoisted_4 = { class: "p-input-icon-right w-full" }
const _hoisted_5 = { class: "col-span-6 md:col-span-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("labels.generic", { pt: "Lista de objetos", en: "Objects List" })), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("i", {
          class: "pi pi-search text-h-primary-500 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSearch()))
        }),
        _createVNode(_component_InputText, {
          modelValue: _ctx.searchWord,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchWord) = $event)),
          placeholder: _ctx.$t('labels.generic', { pt: 'Pesquisar', en: 'Search' }),
          class: "w-full",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onSearch()), ["enter"]))
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.selected,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected) = $event)),
        options: _ctx.filters,
        optionLabel: "name",
        class: "w-full",
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSelect()))
      }, null, 8, ["modelValue", "options"])
    ])
  ]))
}